<template>
  <div>
    <ValidationObserver ref="form">
      <form @submit.prevent="validate">
        <div class="form-row">
          <div class="col-12">
            <ValidationProvider
              name="validationCode"
              rules="required|max:255"
              v-slot="{ passed, failed }"
            >
              <fg-input
                name="validationCode"
                :error="failed ? 'Please enter the validation code.': null"
                :has-success="passed"
                required
                label="Invitation Code"
                placeholder=""
                max-length="255"
                v-model="validationCode"
              />
            </ValidationProvider>
            <ValidationProvider
              name="courseName"
              rules="required|max:255"
              v-slot="{ passed, failed }"
            >
              <fg-input
                name="courseName"
                :error="failed ? 'The name of the Course is required.': null"
                :has-success="passed"
                required
                label="Course Name"
                placeholder=""
                max-length="255"
                v-model="courseName"
              />
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div
            v-if="error"
            style="margin-top:20px;"
            class="col-12 alert alert-danger fade show"
          >
            {{ error }}
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { extend } from 'vee-validate'
import { required, max } from 'vee-validate/dist/rules'
import inviteApi from '@/services/api/invitation.js'

extend('required', required)
extend('max', max)

export default {
  name: 'AcceptInvitationInvite',
  data: function () {
    return {
      validationCode: null,
      courseName: null,
      error: null,
      invitationDetails: null,
      tempHolding: null
    }
  },
  mounted: function () {
    this.validationCode = this.$route.query.code
    this.courseName = this.$route.query.course
  },
  methods: {
    validate: function () {
      return this.$refs.form.validate().then(res => {
        if (res) {
          return inviteApi.validate(this.validationCode, this.courseName)
            .then(response => {
              if (response.ResultCode === 'Success') {
                this.$emit('on-validated', res, response.Details)
                return res
              } else {
                this.error = response.ResultMessage
              }
            })
            .catch(error => {
              this.error = error
              this.$notify({
                message: 'There was an error retrieving your data.',
                icon: 'bi bi-exclamation-circle-fill',
                type: 'error',
                horizontalAlign: 'center',
                timeout: 2000
              })
              return false
            })
        }
      })
    }
  }
}
</script>
